import { render, staticRenderFns } from "./MarketPotential.vue?vue&type=template&id=6b7380e0"
import script from "./MarketPotential.vue?vue&type=script&lang=js"
export * from "./MarketPotential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports